jQuery(document).ready(function ($) {
  function mobFooterNav() {
    if ($(window).width() < 769) {
      $('.footer .footer__nav .menu-item-has-children > a').unbind('click');
      $('.footer .footer__nav .menu-item-has-children > a').click(function (e) {
        $(this).closest('li').find('.sub-menu').toggleClass('active');
        $(this).toggleClass('active');

        return false;
      });
    } else {
      $('.footer .footer__nav .menu-item-has-children > a').unbind('click');
      $('.footer .footer__nav .menu-item-has-children > a').click(function (e) {
        if($(this).attr('href') !== '#') {
          window.location.href = $(this).attr('href');
        }

        return false;
      });
    }
  }

  mobFooterNav();

  $(window).resize(function () {
    mobFooterNav();
  });

  $('.footer .footer__nav .menu-item-has-children > a').each(function () {
    if ($(this).attr('href') !== '#') {
      $(this).next('.sub-menu').prepend('<li class="menu-item menu-item-mob"><a href="' + $(this).attr('href') + '">' + $(this).text() + '</a></li>');
    }
  });

  // Analytics
  $('.onereach-analytics-report__label').click(function () {
    $('.onereach-analytics-report').toggleClass('active');
  });
});